import { useReactiveVar } from "@apollo/client";

import {
  EOrganizationType,
  IUnitDetailsDataHome,
} from "../../interfaces/interfaces";
import { getClimateAlertNames, getWarningNames } from "../../utils/alertUtils";
import { organizationIdNameVar } from "../apollo/LocalState";

import UnitCard from "./UnitCard";

const renderFloorName = ({
  floorName,
  moreThanOneFloor,
}: {
  floorName: string;
  moreThanOneFloor: boolean;
}) => {
  if (floorName === "null" && moreThanOneFloor) {
    return <div className="floor-name menu">No floor assigned</div>;
  }
  if (floorName === "null") {
    return null;
  }
  return <div className="floor-name menu">Floor {floorName}</div>;
};

const Floor: React.FC<{
  data: IUnitDetailsDataHome[];
  floorName: string;
  moreThanOneFloor: boolean;
}> = ({ data, floorName, moreThanOneFloor }) => {
  const organizationIdName = useReactiveVar(organizationIdNameVar);
  return (
    <div className="floor-container">
      {organizationIdName.organizationType !==
        EOrganizationType.PRO_VIEW_ORGANIZATION &&
        renderFloorName({ floorName, moreThanOneFloor })}
      <div className="floor-units">
        {data.map((element: IUnitDetailsDataHome) => {
          const {
            propertyName,
            id,
            alerts,
            isHubless,
            numBrilliantControls,
            numBrilliantPlugs,
            numBrilliantSwitches,
            numIntegrations,
            numResidents,
            numInvitedResidents,
            reconfigurationState,
            warnings,
            subscription,
          } = element;
          const numBrilliants =
            numBrilliantControls + numBrilliantPlugs + numBrilliantSwitches;
          const alertNames = getClimateAlertNames(alerts);
          const warningNames = getWarningNames(warnings);
          return (
            <UnitCard
              key={propertyName}
              isHubless={isHubless}
              propertyId={id}
              alerts={alertNames}
              name={propertyName}
              numBrilliants={numBrilliants}
              numThirdpartyIntegrations={numIntegrations}
              numTenants={numResidents}
              numInvitedResidents={numInvitedResidents}
              reconfigurationState={reconfigurationState}
              warnings={warningNames}
              subscription={subscription}
            />
          );
        })}
      </div>
    </div>
  );
};

export default Floor;
